module.exports = __webpack_public_path__ + "static/media/shieldWhite.pictogram.ddbe1ed0.svg";